import React, { useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Overlay from "../../../../components/Overlay/Overlay";
import { getIsUserPremium } from "../../../../state/selectors/general.selectors";
import isPortal from "../../../../common/helpers/isPortal";
import AMP from "./AMP";
import { useFirstQueryOfTheDay } from "../../../../hooks/firstQueryCheck";

const DisclaimerWrapperAMP = ({ isUserPremium }) => {
  const [showOverlay, setShowOverlay] = useState(true);
  const isClinical = isPortal();
  const handleAgree = () => {
    setShowOverlay(false);
  };
  const isFirst = useFirstQueryOfTheDay();

  if (isClinical || isUserPremium || !isFirst) {
    return <AMP />;
  }
  return (
    <Overlay show={showOverlay} onAgree={handleAgree}>
      <div
        className="tw-p-4 tw-bg-white tw-rounded tw-shadow-lg tw-z-0"
        style={{ filter: showOverlay ? "blur(4px)" : "" }}
      >
        <AMP />
      </div>
    </Overlay>
  );
};

DisclaimerWrapperAMP.propTypes = {
  isUserPremium: PropTypes.bool.isRequired,
};
const mapStateToProps = (state) => {
  return {
    isUserPremium: getIsUserPremium(state),
  };
};

export default connect(mapStateToProps, {})(DisclaimerWrapperAMP);
